// Extrahuje aktuální číslo stránky z odkazu tlačítka.
export const getCurrentPageNumber = (buttonLinkWrapper: HTMLLinkElement): number => {
  if (!buttonLinkWrapper) throw new Error('getCurrentPageNumber: buttonLinkWrapper is not defined');

  const url = new URL(buttonLinkWrapper.href);
  const buttonPage = parseInt(url.searchParams.get('page') || '1');

  return !isNaN(buttonPage) ? buttonPage : 1;
};

// Pokud je wrapperem buttonu odkaz a obsahuje parametr page, tak přidat k odkazu +1
export const increaseButtonLinkParameter = (buttonLinkWrapper: HTMLLinkElement): void => {
  const currentPage = getCurrentPageNumber(buttonLinkWrapper);
  const url = new URL(buttonLinkWrapper.href);

  url.searchParams.set('page', (currentPage + 1).toString());
  buttonLinkWrapper.href = url.toString();
};
